import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

export default class DisbursementRequestStatusSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (status) => {
        this.props.handleChange(status);
    }

    render() {
        const statuses = [
            { value: null, label: 'TODOS' },
            { value: 'PENDING', label: 'PENDIENTE' },
            { value: 'APPROVED', label: 'APROBADO' },
            { value: 'CANCELED', label: 'ANULADO' },
            { value: 'REJECTED', label: 'RECHAZADO' }
        ];
        return (
            <OgaSelect
                bsSize="small"
                placeholder="Estado"
                value={this.props.selection}
                onChange={(status) => this.handleChange(status)}
                options={statuses}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/DisbursementRequestStatusSelect/DisbursementRequestStatusSelect.jsx